
class Gps {
  static getNew () {
    return {
      info: {
        make: '',
        model: '',
        serial_number: '',
        template: ''
      }
    }
  }
}

export { Gps }



// WEBPACK FOOTER //
// ./src/models/gps.js